import { createSelector } from '@reduxjs/toolkit'
import { getContextByEntityId } from '../../getters'

export const selectContextByEntityId = createSelector(
  [getContextByEntityId],
  (context) => context
)
